






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BaseComponent from '@/author/components/BaseComponent.vue';

@Component
export default class QuizBlocking extends BaseComponent {
  // Labels
  @Prop() question!: string;
  @Prop() image!: string;
  @Prop() hiddenTitle!: string;
  @Prop() submitLabel!: string;
  @Prop() correctQuestionTitle!: string;
  @Prop() incorrectQuestionTitle!: string;
  @Prop() tryAgainLabel!: string;
  @Prop() quizInstructions!: string;
  @Prop() correctFeedback!: string;
  @Prop() incorrectFeedback!: string;

  // Accessibility Labels
  @Prop() accessibilityCorrectFeedback!: string;
  @Prop() accessibilityIncorrectFeedback!: string;
  @Prop() accessibilitySelectFeedback!: string;
  @Prop() accessibilityQuizInstructions!: string;

  // Quiz Config
  @Prop({ default: false }) scorable!: boolean;
  @Prop({ default: false }) instantFeedback!: boolean;
  @Prop({ default: 'fixed' }) layout?: string;
}
